import { isProduction } from "helpers/env";

interface IProperties {
  [key: string]: string;
}

// properties allows us to pass whatever additional data we
// deem appropriate for the event, see the docs for reserved properties
// https://segment.com/docs/spec/track/#properties
function trackEvent(event: string, properties: IProperties = {}): void {
  if (isProduction() && window.analytics) {
    window.analytics.track(event, properties);
  } else {
    // tslint:disable-next-line:no-console
    console.log("trackEvent: ", event, properties);
  }
}

export { trackEvent };
